import React, { useEffect, useMemo, useState } from 'react';
import { getMediaBaseUrl } from '../../constants/images';
import { PLAY_STORE_APPS, SITE_CONFIG } from '../../config/siteConfig';
import { isPartnersHost } from '../../utils/hostNavigation';
import { isPepparMobileApp } from '../../utils/nativeAppDetection';
import './PlatformFooter.css';

const GOOGLE_PLAY_BADGE_SRC = `${getMediaBaseUrl()}/images/landing/google-play-badge.png`;

const AuthPlatformFooter: React.FC = () => {
  const year = new Date().getFullYear();
  const [inMobileApp, setInMobileApp] = useState(() => isPepparMobileApp());

  useEffect(() => {
    setInMobileApp(isPepparMobileApp());
    const timer = window.setTimeout(() => setInMobileApp(isPepparMobileApp()), 400);
    return () => window.clearTimeout(timer);
  }, []);

  const apps = useMemo(() => {
    if (isPartnersHost()) {
      return PLAY_STORE_APPS.filter((app) => app.id === 'merchant');
    }
    return PLAY_STORE_APPS;
  }, []);

  const sectionTitle =
    apps.length === 1 ? `Download ${apps[0].name}` : 'Download Peppar apps';

  const showAppDownloads = !inMobileApp && apps.length > 0;

  return (
    <footer
      id="footer"
      className={`footer-platform footer-platform--auth${showAppDownloads ? '' : ' footer-platform--auth-minimal'}`}
    >
      <div className="fp-inner fp-inner--auth">
        {showAppDownloads && (
          <div className="fp-auth-main">
            <p className="fp-auth-apps-title">{sectionTitle}</p>
            {apps.length === 1 && (
              <p className="fp-auth-apps-subtitle">{apps[0].description}</p>
            )}
            <div className="fp-play-badges" aria-label="Download Peppar apps on Google Play">
              {apps.map((app) => (
                <div key={app.id} className="fp-play-badge-item">
                  <a
                    href={app.href}
                    className="fp-play-badge"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Get ${app.name} on Google Play`}
                  >
                    <img src={GOOGLE_PLAY_BADGE_SRC} alt="" width={646} height={250} />
                  </a>
                  {apps.length > 1 && (
                    <>
                      <p className="fp-play-badge-name">{app.name}</p>
                      <p className="fp-play-badge-desc">{app.description}</p>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="fp-bottom fp-bottom--auth">
          <p className="fp-copy">
            © {year}. All Rights Reserved by {SITE_CONFIG.legalName}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default AuthPlatformFooter;
